/**
 * PlatformOverview Page
 * Displays all available pages and features based on access levels
 */

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useMsal } from '@azure/msal-react';
import { isAuthenticated } from '../services/authService';
import Header from '../components/landing/Header';
import PublicPages from '../components/landing/PublicPages';
import Footer from '../components/landing/Footer';

export default function PlatformOverview() {
    const navigate = useNavigate();
    const { handleLogout } = useAuth();
    const { accounts } = useMsal();

    const handleLoginClick = () => {
        navigate('/');
    };

    const handleLogoutClick = async () => {
        await handleLogout();
        navigate('/');
    };

    const userName = accounts.length > 0 ? accounts[0].name : undefined;

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Header
                isAuthenticated={isAuthenticated()}
                userName={userName}
                onSignIn={handleLoginClick}
                onSignOut={handleLogoutClick}
            />

            <PublicPages />

            <Footer />
        </div>
    );
}
